<script lang="ts">
	import IncomeForm from "./components/IncomeForm.svelte";
</script>
<main>	
  <link rel='stylesheet' href='https://test.apps.cdn.protective.com/dms/svelte/estatemaximizercalculator/vendor/bootstrap/css/bootstrap.min.css'>
  <script src="https://test.apps.cdn.protective.com/dms/svelte/estatemaximizercalculator/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
	<link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet">
	<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600,300" rel="stylesheet">
	<link href='https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300,600,700' rel='stylesheet'> 
  <!-- <link rel="stylesheet" href="//content.externalsystems.protective.com/styles/default.css" /> -->
  <IncomeForm />
  
</main>
<style lang="scss">
 :global(.component-content .row){     
  max-height: 96px !important; 
}
:global(.container.page){           
  width: 1364px !important;
  max-width: 1364px !important;
  background-color:#F7F7F7;
  padding:52px 0px;   
  @media(max-width:992px){ 
    width:100% !important;       
  }                         
}
:global(.container.content){     
  max-width: 904px;
  margin: 0 auto;     
  padding:0;
  @media(max-width:992px){ 
    width:100%;          
  }  
}
:global(.container.form){     
  max-width: 674px;
  margin-left:auto;
  margin-right: auto;
  overflow: visible;     
  @media(max-width:992px){ 
        margin-left: 0;          
  } 
}
:global(.calculator){
  width:100%
}
:global(.info-tooltip) { 
    position: relative;
    margin-left: 18px;    
    overflow: visible; 
    z-index:5;
}
:global(.info-tooltip:before) {
  content: attr(data-text); 
  position:absolute;
  bottom:100%;
  transform:translateX(-50%);
  left:50%;
  margin-bottom:15px; 
  width:350px;
  padding:10px;
  border-radius:5px;
  background:#7D55C7;
  color: #fff; 
  font-family: Open Sans;
  font-size: 14px;
  line-height: 19px;
  font-weight: normal;
  display:none;    
}
:global(.info-tooltip:after) {
  content: "";
  position:absolute;
  bottom:100%;
  margin-bottom:-5px;
  left:50%;
  transform:translateX(-50%); 
  border:10px solid #7D55C7;
  border-color: #7D55C7 transparent transparent transparent; 
  display:none;
}
:global(.info-tooltip:hover:before, .info-tooltip:hover:after) {
  display:block;
  overflow: visible; 
}
:global(.info){
  content: "info";
  font-family: "Material Icons Outlined";
  font-size: 24px;
  text-decoration: none;
  color: #696969;
  font-weight: lighter;
  vertical-align: bottom;
}
:global(.textbox){     
     max-width: 100% !important;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: flex-start;
     padding: 10px 0px; 
     position: static;
     width: 100%;
     height: 48px;
     left: 0px;
     top: 32px;
     background: #FFFFFF; 
     border: 2px solid #C6C6C6;
     box-sizing: border-box;
     border-radius: 100px; 
     flex: none;
     order: 1;
     align-self: stretch;
     flex-grow: 0;
     margin: 8px 0px 0px 0px;          
     font-family: Open Sans;
     font-style: normal;
     font-weight: normal;
     font-size: 16px;
     line-height: 30px; 
     display: flex;
     align-items: center; 
     color: #696969; 
     text-indent: 16px;
    @media(max-width:992px){
      width: 100%;        
    }            
   }  
:global(.textbox::content){
  border: 2px solid #50C3FF;
}
:global(.label){
  position: static;
  width: 350px;
  height: 24px;
  left: 0px;
  top: 0px; 
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}     
:global(.bold){
  font-weight: 700;    
}
</style>